const DEFAULT_VERSION_NUMBER="10302026-3040";

module.exports = { versionNo: DEFAULT_VERSION_NUMBER };
